<template lang="pug">

  .SampleListItem.SampleListItem-fluid
    .SampleListItem_container(v-if="item")
        router-link(
          :to="item.url"
          )
          ul.SampleListItem-listIcons(v-if="(item._data.images && item._data.images.length > 1) || item._data.iframe === true || item._data.availability_thin_section_photos === true")
            li(v-if="item._data.images.length > 1")
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 29" width="37" height="29"><g fill="#ffefce"><path d="m34.695312 5.300781-4.464843.378907V2.984375l-5.523438.714844V.640625L2.304688 5.457031v18.085938l22.402343 4.816406v-3.058594l5.523438.714844v-2.699219l4.464843.382813ZM29.113281 24.71875l-4.410156-.570312v-4.503907h-1.117187v7.304688L3.417969 22.613281V6.386719l20.167969-4.335938v7.003907h1.117187V4.851562l4.410156-.570312Zm4.46875-2.257812-3.351562-.289063V6.828125l3.351562-.289063Zm0 0"/><path d="M24.714844 10.996094h-1.113282v2.78125h-2.535156v1.144531h2.535156v2.789063h1.113282v-2.789063H27.1875v-1.144531h-2.472656Zm0 0"/></g></svg>
              span.SampleListItem-images#images {{ $t('icon.images') }}
            li(v-if="item._data.iframe === true")
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 29" width="37" height="29"><g fill="#ffefce"><path d="M2.257812 1.792969v24.652343h31.730469V1.792969Zm30.636719 23.539062H3.351562V2.90625h29.542969Zm0 0"/><path d="M15.0625 17.023438c-.179688.265624-.421875.46875-.738281.617187-.316407.148437-.683594.222656-1.101563.222656-.632812 0-1.148437-.152343-1.550781-.453125-.402344-.296875-.625-.6875-.671875-1.164062l-.007812-.066406H9.847656l.007813.082031c.042969.511719.207031.964843.492187 1.367187.28125.394532.667969.710938 1.160156.941406.488282.226563 1.058594.339844 1.714844.339844.636719 0 1.207032-.121094 1.707032-.363281.492187-.246094.886718-.578125 1.171874-1.007813.285157-.425781.429688-.90625.429688-1.445312v-.011719c0-.691406-.214844-1.246093-.640625-1.664062-.433594-.417969-.996094-.65625-1.6875-.71875v-.023438c.394531-.085937.746094-.230469 1.050781-.4375.300782-.203125.542969-.464843.710938-.769531.171875-.3125.257812-.667969.257812-1.066406v-.011719c0-.496094-.125-.925781-.371094-1.300781-.25-.375-.601562-.667969-1.054687-.882813-.449219-.210937-.976563-.316406-1.585937-.316406-.59375 0-1.121094.109375-1.574219.328125s-.820313.527344-1.097657.917969c-.273437.398437-.441406.859375-.492187 1.386719l-.007813.066406h1.144532l.007812-.066406c.035156-.328126.140625-.609376.316406-.84375.175782-.238282.410157-.421876.703126-.550782.292968-.128906.625-.191406 1-.191406.386718 0 .71875.0625.988281.1875.269531.128906.476562.308594.617187.546875.140625.234375.210938.523437.210938.863281v.015625c0 .324219-.082032.613281-.242188.867188-.164062.25-.390625.453125-.679687.597656-.296875.144531-.628907.214844-1.007813.214844h-1.144531V14.25h1.195313c.671874 0 1.203124.160156 1.589843.484375.390625.316406.585938.777344.585938 1.371094v.011719c0 .34375-.089844.644531-.261719.90625Zm9.140625 1.148437c.667969-.378906 1.179687-.933594 1.539063-1.664063.355468-.722656.53125-1.59375.53125-2.613281v-.011719c0-1.015624-.179688-1.882812-.535157-2.605468-.359375-.71875-.871093-1.269532-1.542969-1.65625-.667968-.378906-1.476562-.574219-2.417968-.574219h-3.203125v9.699219h3.203125c.945312 0 1.753906-.1875 2.425781-.574219Zm-4.441406-.511719v-7.523437h1.9375c.722656 0 1.335937.144531 1.832031.433593.5.289063.878906.714844 1.140625 1.277344.257813.558594.390625 1.242188.390625 2.050782v.011718c0 .800782-.128906 1.480469-.390625 2.039063-.261719.558593-.640625.984375-1.140625 1.277343-.5.289063-1.109375.433594-1.832031.433594Zm0 0"/></g></svg>
              span.SampleListItem-images#icon3d {{ $t('icon.3d') }}
            li(v-if="item._data.availability_thin_section_photos === true")
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 29" width="37" height="29"><g fill="#ffefce"><path d="M2.304688 1.839844v25.320312h32.390624V1.839844Zm27.175781 24.175781-5.660157-5.800781c.285157-.269532.554688-.558594.796876-.863282l6.511718 6.664063ZM18.5 21.195312c-3.726562 0-6.757812-3.105468-6.757812-6.921874 0-3.816407 3.03125-6.917969 6.757812-6.917969 3.726562 0 6.761719 3.101562 6.761719 6.917969 0 3.816406-3.035157 6.921874-6.761719 6.921874Zm15.078125 4.820313h-.867187l-7.441407-7.621094C25.972656 17.1875 26.375 15.78125 26.375 14.273438c0-4.445313-3.53125-8.0625-7.875-8.0625s-7.875 3.617187-7.875 8.0625c0 4.449218 3.53125 8.066406 7.875 8.066406 1.648438 0 3.171875-.519532 4.441406-1.40625l4.960938 5.082031H3.421875V2.984375h30.15625Zm0 0"/><path d="M13.132812 14.273438H14.25c0-2.398438 1.90625-4.351563 4.25-4.351563V8.777344c-2.960938 0-5.367188 2.46875-5.367188 5.496094Zm0 0"/></g></svg>
              span.SampleListItem-images#thin_blade {{ $t('icon.thin_blade') }}
          img.SampleListItem_thumb(
            :src="item.thumbnail"
            :data-loaded="loaded"
            v-show="loaded"
            ref="img"
          )
          span.SampleListItem_touch_name(v-if="!withoutDetails && isTouchDevice") {{ isSampled ? item.name : item.subtitle }}
          .SampleListItem_details(v-if="!withoutDetails && !isTouchDevice")
            p.SampleListItem_title
              span.SampleListItem_title_block {{ isSampled ? item.name : item.subtitle }}
            p.SampleListItem_id(v-if="item.number") {{ item.number }}
            .SampleListItem_type_container()
              p.SampleListItem_type {{ type }}
              .sep

            p.SampleListItem_sample {{ isSampled ? $t('drawer.sample') : $t('collection.drawer') }} {{ item.number }}

</template>

<script>
import { mapGetters } from 'vuex'
import TextAutoResize from '@/components/common/TextAutoResize'

export default {
  components: { TextAutoResize },
  props: {
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      required: false
    },
    number: {
      type: Number,
      default: 0
    },
    withoutDetails: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      loaded: false,
      isTouchDevice: false
    }
  },
  watch: {
    item (newVal, oldVal) {
      if (newVal == null || oldVal == null || newVal.url != oldVal.url) {
        this.$nextTick(() => {
          this.listenImageLoad()
        })
      } else {
        this.loaded = true
      }
    }
  },
  computed: {
    ...mapGetters(['isSampled']),
    thumb () {
      if (this.item.attributes) {
        return this.item.photos[0].links.sample_home_small.href
      } else if (this.item.media) {
        return this.item.media[0].sample_home_small
      } else if (this.item.images) {
        return this.item.images[0].sample_search_desktop_small
      }
    },
    title () {
      if (this.item.attributes) {
        return this.item.attributes.name
      } else if (this.item.title) {
        return this.item.title
      } else if (this.item.name) {
        return this.item.name
      }
    },
    type () {
      if (this.item.type_of_sample) {
        return this.item.type_of_sample
      } else if (this.item.type) {
        if (this.item.type.indexOf('sample') > -1) return this.$t('sample.types.' + this.item.type)
        else return this.$t('sample.types.sample--' + this.item.type)
      } else if (!this.isSampled) {
        return this.item.name;
      }
      return null
    }
  },
  methods: {
    listenImageLoad () {
      this.loaded = false
      let img = this.$refs.img
      if (img) {
        if (img.width) this.imageLoadedHandler()
        else img.addEventListener('load', this.imageLoadedHandler)
      }
    },

    imageLoadedHandler () {
      this.loaded = true

      let img = this.$refs.img
      if (img) {
        img.removeEventListener('load', this.imageLoadedHandler)
      }
    }
  },
  mounted () {
    if (this.$tools.isTouchDevice()) {
      this.isTouchDevice = true
    }
    this.listenImageLoad()
  }
}

</script>

<style lang="stylus">

.SampleListItem
  position relative

  &-listIcons
    position absolute
    top 20px
    right 20px
    z-index 1

    li
      display block !important
      margin-bottom 15px

      &:last-child
        margin-bottom 0

  &-images
    clip rect(0 0 0 0)
    -webkit-clip-path inset(50%)
    clip-path inset(50%)
    height 1px
    overflow hidden
    position absolute
    white-space nowrap
    width 1px

  .SampleListItem_touch_name
    color #fff
    width 100%
    margin 5px
    padding 20px
    position absolute
    bottom 0

    @media screen and (max-width: 1024px)
      font-size: 2vw;
      line-height: 3vw;

    @media screen and (max-width: 768px)
      font-size: 2.8vw;
      line-height: 3.8vw;

    @media screen and (max-width: 400px)
      font-size: 4vw;
      line-height: 4.5vw;

  .temp
    position absolute
    font-size 30px
    color white

  &_container
    position relative
    margin 0px
    box-sizing border-box
    color white
    width 100%
    padding-bottom 100%
    background-color $black
    border: 1px solid $grey-1;
    border-top 0
    overflow hidden
    transition transform 2s $ease, opacity .3s ease

  &_sample

    display none
    text-decoration none
    color white
    font-size: 14px;
    letter-spacing: 2px;
    text-align center
    text-transform uppercase
    // margin auto auto 0px auto
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;

  a
    position: absolute
    display: flex
    flex-direction column
    align-items center
    justify-content center
    top 0
    right 0
    bottom 0
    left 0
    text-decoration none
    padding 20px 20px 30px 20px
    transition transform 2s $ease, opacity .3s $ease

    @media $mq_s_only

      padding 20px

    .show-sample &
      opacity 1
    // &:hover
    &.hover

      transform scale(0.92)

  &_details

    position absolute
    top 20px
    left 20px
    display flex
    height calc(100% - 40px)
    width calc(100% - 40px)
    flex-direction column
    will-change transform // prevent text rendering issue when translate from outside viewport
    // display none // to limit Recalculate styles

  &_fluid
    width calc(100% - 40px)

  &-fluid

    .SampleListItem_thumb

      height 90%
      width auto

  &-big
    width calc(495px - 40px)
    height calc(495px - 40px)

  &-medium
    width calc(295px - 40px)
    height calc(295px - 40px)

  &-small

    width calc(248px - 40px)
    height calc(248px - 40px)

  &_title
    font-size: 18px
    letter-spacing: 1.8px;
    color white
    font-family: 'Sectra Display'
    text-align: center;
    margin auto auto 0px auto

  &_id

    display none

  &_type

    font-weight 600
    font-size: 12px
    color $beige
    margin 0px
    padding 0px
    letter-spacing: 2px;
    transform-origin 0 0
    position absolute
    left: -5px;
    top: 195px;
    height: 12px;
    overflow: hidden;
    width: 150px;
    text-align: right;
    transform rotate(-90deg)

  &_type_container

    position absolute
    top 0px
    display flex
    flex-direction column
    left 0px

  .sep

    background-color $beige
    width 2px
    height 30px
    margin 0px auto 15px auto

  img

    object-fit cover
    height auto
    width 100%
    margin auto
    opacity 0.5
    transition all 3s $ease
    // transform rotateZ(-45deg)
    position absolute
    // transition: $homeSearchResults_searchToHome_transition
    transition: transform 1.2s ease, opacity .3s ease

    @media $mq_s_only

      height auto
      width 100%

    .is-searchMode &
      transform rotateZ(0deg)
    .is-transitioning
      opacity 0

  &-in-drawer
    text-overflow: ellipsis;

    .SampleListItem_title

      opacity 1
      position absolute
      color white
      text-overflow: ellipsis;
      top 50%
      left 50%
      transform translate(-50%,50%) scale(1.2)
      transition all 1s $ease
      transition-delay 0.3s

    .SampleListItem_sample

      display block
      opacity 1
      transform translateY(0%)
      transition all 1s $ease
      transition-delay 0.5s

    .SampleListItem_type_container

      .sep

        height 30px
        transform-origin top center
        transition all 1s $ease
        transition-delay 0.3s

      p

        opacity 1
        overflow unset
        left -9px
        transition all 1s $ease
        transition-delay 0.3s

  &-in-search

    // background transparent

    a

      background black
      overflow hidden

    .SampleListItem

      &_sample

        display none

      &_title

        top unset
        left unset
        transform none
        box-sizing border-box
        width 100%
        position relative
        margin auto auto 0px auto
        text-align center

    &.hover

      .SampleListItem

        &_title
          transform none

  &.v-enter-active
    transition: all .3s ease
  &.v-leave-active
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)
  &.v-enter, &.fade-leave-to
    opacity: 0

body.isNoTouchDevice

  .SampleListItem
    &-in-drawer, &-fluid
      text-overflow: ellipsis;

      .SampleListItem_details
        opacity 0
        transform translateY(10%) scale(1.2)
        transition all .6s $ease

      .SampleListItem_thumb

        transition all 1s cubic-bezier(0.23, 1, 0.32, 1);

      .SampleListItem_title

        font-size: 1.6em
        letter-spacing: 1.5px;
        position absolute
        color white
        text-overflow: ellipsis;
        top 50%
        left 50%
        transform translate(-50%,-50%) scale(1)
        transition all 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);

        .SampleListItem_title_block
          font-size 1.8vw
          line-height 2vw
          margin 0
          padding 0

          @media screen and (max-width: 1024px)
            font-size: 2.5vw;
            line-height: 3vw;

          @media screen and (max-width: 768px)
            font-size: 4vw;
            line-height: 5vw;

          @media screen and (max-width: 400px)
            font-size: 6vw;
            line-height: 7vw;

      .SampleListItem_sample

        display block
        opacity 1
        transform translateY(0%)
        transition all 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);

      .SampleListItem_type_container

        .sep

          // height 0px
          transition all 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);

        p

          opacity 1
          overflow unset
          left -9px
          transition all 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);

      .SampleListItem_details
          .SampleListItem_title
            opacity 1
            transform translate(-50%,-50%)
            transition-delay 0.3s

          .SampleListItem_sample
            opacity 1
            transform translateY(0%)
            transition-delay 0.5s

          .SampleListItem_type_container
            .sep
              transform scaleY(1)
              transition-delay 0.3s

            p
              opacity 1
              transition-delay 0.2s

    &:hover
      .SampleListItem_container
        transform scale(.92)

        img
          opacity 1

      .SampleListItem_details
        opacity 1
        transform translateY(0%) scale(1)

</style>
